export default "__VITE_ASSET__9Xgmipey__"